import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28a64449"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "o-mainHeader",
  role: "banner",
  "data-js": "seatmap-controls"
}
const _hoisted_2 = { class: "l-container is-fullwidth" }
const _hoisted_3 = { class: "o-mainHeader__inner" }
const _hoisted_4 = ["content"]
const _hoisted_5 = {
  key: 1,
  class: "o-mainHeader__blankLogoPlaceholder"
}
const _hoisted_6 = {
  key: 2,
  class: "o-mainHeader__utilities"
}
const _hoisted_7 = { class: "a-iconArr icon-larr" }
const _hoisted_8 = { class: "o-mainHeader__menuBackTitle" }
const _hoisted_9 = {
  key: 1,
  class: "o-mainHeader__utilitiesNav"
}
const _hoisted_10 = ["data-qa"]
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "o-mainHeader__utilitiesNavItemDot" }, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "o-mainHeader__utilitiesNavItem -less-margin"
}
const _hoisted_14 = {
  key: 0,
  class: "o-mainHeader__dropdown",
  ref: "languageDropdown"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 4,
  class: "o-mainHeader__nav"
}
const _hoisted_17 = { class: "o-mainHeader__mainMenu" }
const _hoisted_18 = ["href", "aria-label", "onClick"]
const _hoisted_19 = {
  key: 5,
  class: "o-mainHeader__utilitiesDesktop"
}
const _hoisted_20 = ["href", "aria-label"]
const _hoisted_21 = ["href", "aria-label", "data-qa"]
const _hoisted_22 = {
  key: 0,
  class: "o-mainHeader__utilitiesNavItemDot"
}
const _hoisted_23 = {
  key: 1,
  class: "o-mainHeader__triggerMenuIcon"
}
const _hoisted_24 = { class: "l-container is-fullwidth" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoComponent = _resolveComponent("LogoComponent")!
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_QuickSearch = _resolveComponent("QuickSearch")!
  const _component_QuickSearchResults = _resolveComponent("QuickSearchResults")!
  const _component_MenuComponent = _resolveComponent("MenuComponent")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.data.logo)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("meta", {
                itemprop: "name",
                content: _ctx.data.logo.name
              }, null, 8, _hoisted_4),
              (_ctx.data.logo)
                ? (_openBlock(), _createBlock(_component_LogoComponent, {
                    key: 0,
                    logo: _ctx.data.logo
                  }, null, 8, ["logo"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_5)),
        (_ctx.menuActive && !_ctx.searchActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.activeSection && !_ctx.profileOnly)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "o-mainHeader__menuBack",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menuBack()))
                  }, [
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_component_IconComponent, {
                        "icon-id": _ctx.IconName.ArrowSlim
                      }, null, 8, ["icon-id"])
                    ]),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.activeSection.title), 1)
                  ]))
                : (_openBlock(), _createElementBlock("nav", _hoisted_9, [
                    (_ctx.shouldDisplayProfile())
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "o-mainHeader__utilitiesNavItem",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleContent(_ctx.MainHeaderTitle.PROFILE, $event))),
                          "data-qa": _ctx.MainHeaderQASelectors.ICON_PROFILE
                        }, [
                          _createVNode(_component_IconComponent, {
                            "icon-id": _ctx.IconName.Profile
                          }, null, 8, ["icon-id"])
                        ], 8, _hoisted_10))
                      : _createCommentVNode("", true),
                    (_ctx.shouldDisplayCart())
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "o-mainHeader__utilitiesNavItem",
                          href: _ctx.cartUrl
                        }, [
                          _createVNode(_component_IconComponent, {
                            "icon-id": _ctx.IconName.Cart
                          }, null, 8, ["icon-id"]),
                          _hoisted_12
                        ], 8, _hoisted_11))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "o-mainHeader__dropdownWrapper",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleLanguageDropdown($event)))
                    }, [
                      (_ctx.getNonSelectableLanguageConfiguration())
                        ? (_openBlock(), _createElementBlock("a", _hoisted_13, [
                            _createVNode(_component_IconComponent, {
                              "icon-id": _ctx.getNonSelectableLanguageConfiguration().icon
                            }, null, 8, ["icon-id"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.getNonSelectableLanguageConfiguration().lang.toUpperCase()), 1)
                    ]),
                    _createVNode(_Transition, { name: "dropdown" }, {
                      default: _withCtx(() => [
                        (_ctx.isLanguagedropdownVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.langSwitcher, (config) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  class: _normalizeClass([{'-disabled': config.lang !== _ctx.getSelectableLanguageConfiguration().lang}, "o-mainHeader__dropdownOption"]),
                                  onClick: ($event: any) => (_ctx.toggleLanguage(config.lang !== _ctx.getSelectableLanguageConfiguration().lang))
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([{
                                        'o-mainHeader__circle--filled': config.lang !== _ctx.getSelectableLanguageConfiguration().lang,
                                        'o-mainHeader__circle--empty': config.lang === _ctx.getSelectableLanguageConfiguration().lang
                                         }, "o-mainHeader__circle"])
                                  }, null, 2),
                                  _createElementVNode("strong", null, _toDisplayString(`${config.lang.toUpperCase()} - ${config.name}`), 1)
                                ], 10, _hoisted_15))
                              }), 256))
                            ], 512))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.isQuickSearchEnabled())
          ? (_openBlock(), _createBlock(_component_QuickSearch, {
              key: 3,
              isActive: _ctx.searchActive,
              searchParam: _ctx.data.quickSearch.searchString,
              searchUrl: _ctx.data.quickSearch.searchPath,
              onToggleSearch: _ctx.toggleSearch,
              onUpdateSearch: _ctx.updateSearch,
              ref: "quickSearch"
            }, null, 8, ["isActive", "searchParam", "searchUrl", "onToggleSearch", "onUpdateSearch"]))
          : _createCommentVNode("", true),
        (_ctx.data.menu)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_16, [
              _createElementVNode("ul", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.menu, (item, idx) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: idx,
                    class: _normalizeClass(['o-mainHeader__mainMenuItem'])
                  }, [
                    _createElementVNode("a", {
                      href: item.url,
                      "aria-label": item.title,
                      onClick: ($event: any) => (_ctx.toggleContent(item.sectionName, $event)),
                      class: _normalizeClass([
                                   'o-mainHeader__mainMenuItemLink',
                                   {'is-selected': _ctx.activeSection && item.name === _ctx.activeSection.name}
                               ])
                    }, _toDisplayString(item.title), 11, _hoisted_18)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.profile || _ctx.data.quickSearch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_ctx.data.quickSearch)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "o-mainHeader__utilitiesDesktop-action",
                    href: _ctx.data.quickSearch.searchPath,
                    "aria-label": _ctx.searchTranslation,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)))
                  }, [
                    _createVNode(_component_IconComponent, {
                      "icon-id": _ctx.IconName.Search
                    }, null, 8, ["icon-id"])
                  ], 8, _hoisted_20))
                : _createCommentVNode("", true),
              (_ctx.data.profile)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "o-mainHeader__utilitiesDesktop-action",
                    href: _ctx.profileConfiguration.url,
                    "aria-label": _ctx.profileConfiguration.name,
                    "data-qa": _ctx.MainHeaderQASelectors.ICON_PROFILE,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleContent(_ctx.MainHeaderTitle.PROFILE, $event)))
                  }, [
                    _createVNode(_component_IconComponent, {
                      "icon-id": _ctx.IconName.Profile
                    }, null, 8, ["icon-id"]),
                    (_ctx.shouldDisplayCart())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_21))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.menu || _ctx.data.profile || _ctx.data.langSwitcher)
          ? (_openBlock(), _createElementBlock("div", {
              key: 6,
              class: _normalizeClass(['o-mainHeader__triggerMenu', {'is-opened': _ctx.menuActive}]),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.actionMenu(_ctx.MainHeaderTitle.PROFILE, $event)))
            }, [
              (_ctx.searchActive)
                ? (_openBlock(), _createBlock(_component_IconComponent, {
                    key: 0,
                    "icon-id": _ctx.IconName.ArrowSlim
                  }, null, 8, ["icon-id"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_23))
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({
                'o-mainHeader__drawer': true,
                'is-opened': _ctx.menuActive,
                'is-narrow': _ctx.isActiveSection(_ctx.MainHeaderTitle.PROFILE)
             })
    }, [
      _createElementVNode("div", _hoisted_24, [
        (_ctx.data.quickSearch && _ctx.searchActive)
          ? (_openBlock(), _createBlock(_component_QuickSearchResults, {
              key: 0,
              query: _ctx.searchString,
              results: _ctx.searchResults,
              searchUrl: _ctx.data.quickSearch.searchPath,
              searchParam: _ctx.data.quickSearch.searchString,
              onUpdateSearch: _ctx.updateSearchQuery
            }, null, 8, ["query", "results", "searchUrl", "searchParam", "onUpdateSearch"]))
          : (_openBlock(), _createBlock(_component_MenuComponent, {
              key: 1,
              cartStatus: _ctx.cartStatus,
              userStatus: _ctx.userStatus,
              data: _ctx.data,
              activeSection: _ctx.activeSection,
              languageConfiguration: _ctx.getSelectableLanguageConfiguration(),
              onToggleContent: _ctx.toggleContent
            }, null, 8, ["cartStatus", "userStatus", "data", "activeSection", "languageConfiguration", "onToggleContent"]))
      ])
    ], 2)
  ]))
}